import { create } from "zustand"
import type { Me } from "@/types/auth"

/**
 * Who is signed in, as last reported by GET /auth/me. Nothing here is
 * persisted: the session lives in an HttpOnly cookie the page cannot read, and
 * every reload asks the API again. No token is ever held in browser storage.
 */
type AuthStatus = "unknown" | "authenticated" | "anonymous"

interface AuthStore {
  me: Me | null
  status: AuthStatus
  setMe: (me: Me) => void
  clear: () => void
}

export const useAuthStore = create<AuthStore>()((set) => ({
  me: null,
  status: "unknown",
  setMe: (me) => set({ me, status: "authenticated" }),
  clear: () => set({ me: null, status: "anonymous" }),
}))

/** Role names (UI hints only; the API enforces every permission). */
export function useRoles(): string[] {
  return useAuthStore((s) => s.me?.user.roles ?? EMPTY)
}
const EMPTY: string[] = []
